import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from '../../axiosConfig'; // Adjust the path as needed


function ClubLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post("/myclub/login/", {
        username,
        password,
      });

      // Save tokens in localStorage
      localStorage.setItem("access_token", response.data.access);
      localStorage.setItem("refresh_token", response.data.refresh);

      // Store user profile with is_club flag for navbar display
      localStorage.setItem("user_profile", JSON.stringify({
        is_club: true,
        club_id: response.data.club_id,
      }));

      // Redirect to the dashboard
      navigate(`/myclub/dashboard/`);
    } catch (error) {
      setError(error.response?.data?.error || "Login failed. Please try again.");
    }
  };

  return (
      <div className="login-container">
        <h2 className="login-header">Club Login</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <input
              className="login-input"
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
          />
          <input
              className="login-input"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
          />
          <button type="submit" className="login-button">Login</button>
        </form>
        {error && <p style={{color: "red"}}>{error}</p>}
      </div>
  );
}

export default ClubLogin;
